import { useMemo } from 'react';

import { HKD, USDC } from '@constants/base';
import { helper } from '@utils/index';

import { useMarketSymbols } from './useMarketSymbols'
import { usePrecision } from './usePrecision';

interface IUseUsdtValueParams {
  /** 币种 */
  coinCode: string;
  /** 数量 */
  count: number;
}

/** 计算传入的币种金额换算成USDT约等于多少USDT 返回的是约等于多少USDT 法币除外 */
export const useUsdtValue = ({ coinCode, count }: IUseUsdtValueParams) => {
  const marketSymbols = useMarketSymbols();
  const precision = usePrecision({ coinCode });
  const value = useMemo(() => {
    if (coinCode === 'USDT' || coinCode === USDC || coinCode === HKD) {
      return `${helper.formatFixNumString(count, precision)} ${coinCode}`;
    }
    const coinSymbol = marketSymbols.find(item => item.coinCode === `${coinCode}_USDT`);
    return `≈${helper.formatFixNumString(count * Number(coinSymbol?.priceLast), precision)} USDT`;
  }, [coinCode, count, marketSymbols])
  return value;
}
